import * as React from "react";
import { injectIntl, InjectedIntlProps } from "react-intl";
import "./DosageReport.less";
import { Tabs, DatePicker } from "antd";
import DosageReportChart from "./DosageReportChart";
import DosageReportTable from "./DosageReportTable";
import { dataStore } from "src/models/DataStore";
import {observer} from "mobx-react";
const { TabPane } = Tabs;
const { MonthPicker } = DatePicker;

@observer
class DosageReport extends React.Component<InjectedIntlProps, {} > {

    public constructor(props: InjectedIntlProps) {
        super(props);
    }

    private handleSelectMonth = async (date: any): Promise<void> => {
        dataStore.dosageMonth = date;
    }
    public render(): React.ReactNode {
        const {intl} = this.props;
        const operations = <MonthPicker size={"small"}
                                        style={{marginRight: 20}}
                                        onChange={this.handleSelectMonth}
                                        placeholder="Select month" />;
        return (
            <div className="product-center-box">
                <div className="portal-room-outbox">
                    <div className="portal-room-chart">
                        <div className="portal-room-box-mid">
                            <Tabs style={{marginLeft: 20, marginRight: 20}} defaultActiveKey="1" tabBarExtraContent={operations}>
                                <TabPane tab={intl.formatMessage({ id: "month-dosage" })} key="1">
                                    <DosageReportTable/>
                                </TabPane>
                                <TabPane tab={intl.formatMessage({ id: "month-trend" })} key="2">
                                    <DosageReportChart/>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(DosageReport);





// WEBPACK FOOTER //
// ./src/components/portal/dataCenter/DosageReport.tsx